export * from "modules/DealerLocationDetails/components/General/components/CompanyStampUpload/hooks/useUploadCompanyStampMutation";
